import { gql } from '@efficiently/client-core-graphql-models';

export const GET_FOLDERS = gql(`
	query GetFolders($projectId: String) {
		folders(projectId: $projectId) {
			...FolderFields
		}
	}
`);
